import { SESSION_UPDATE_SESSION } from '../actions/session.actions'

const initialState = {
  user: null,
  permissions: null,
  profile: null,
  notifications: {}
}

const sessionReducer = (state = initialState, action) => {
  const newState = { ...state }
  switch (action.type) {
    case SESSION_UPDATE_SESSION: {
      const { user } = action.payload
      if (!user) {
        newState.user = null
        newState.permissions = null
        break
      }
      newState.user = {
        userId: user._id,
        fullName: user.fullName,
        roles: user.roles,
        email: user.email,
        code: user.code,
        photo: user.photo,
        isDeleted: user.isDeleted,
        isImpersonate: user.isImpersonate || false,
        notifications: user.notifications || {}
      }
      newState.permissions = user.permissions
      newState.profile = user.profile || null
      newState.notifications = user.notifications || {}
      break
    }
    default:
      break
  }

  return newState
}

export default sessionReducer
